import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Card, Button } from 'react-bootstrap'
import Swal from 'sweetalert2'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { editMultiSchool, getMultiSchool } from '../../actions/usersActions'
import useAuth from '../../context/auth/useAuth'

export default function Profile() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {client} = useAuth()

    const {user, resultuser} = useSelector(state=>state.users)
    
    const [formState, setFormState] = useState({})


    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }
    const handleAdd = async(e) => {
        e.preventDefault()

        if(formState.email !== null && formState.email !== '' && formState.email !== undefined){
            dispatch(editMultiSchool(formState, client?.id))
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('users.pleasecomplete')
            })
        }
    }

    useEffect(() => {
        if (client) {
            dispatch(getMultiSchool(client.id))
        }
    }, [client, dispatch])

    useEffect(() => {
        if (user) {
            setFormState({
                email: user.email,
                schools: user.schools?.map(school => {
                    return { label: school.name, value: school.id }
                }) || []
            })
        }
    }, [user])

    useEffect(() => {
        if (resultuser) {
            dispatch({
                type: 'USER_RESET_RESULT'
            })
            switch (resultuser) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('users.schooledit')
                    })
                    dispatch(getMultiSchool(client.id))
                    setFormState({
                        ...formState,
                        password: null
                    })
                    break
                default:
                    break
            }
        }
        // eslint-disable-next-line
    }, [resultuser, dispatch])

    return (
        <>
        	<Container className='cuerpo'>
				<Row>
                    <h1>{t('admin.dashboard.multiSchoolData')}</h1>
				</Row>
				<Row className="mt-2">
					<Col>
						<Card className='mb-5 sombra'>
                            <Card.Body className='px-5 pt-5'>
                                <Form onSubmit={handleAdd} autoComplete='off'>
                                    <Row>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label>{t('signin.email')}</Form.Label>
                                            <Form.Control
                                                type='email'
                                                name='email'
                                                value={formState.email ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label>{t('signin.password')}</Form.Label>
                                            <Form.Control
                                                type='password'
                                                name='password'
                                                value={formState.password ||  ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="my-3 d-flex justify-content-end">
                                        <Col xs='12' lg='4'>
                                            <Button type="submit" className="btn-primary w-100 my-2">{t('config.school.updateuser')}</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
						</Card>
					</Col>
				</Row>
			</Container>
        </>
    )
}